import { render, staticRenderFns } from "./DiagnosticaConversioni.vue?vue&type=template&id=506caa8e&scoped=true"
import script from "./DiagnosticaConversioni.vue?vue&type=script&lang=js"
export * from "./DiagnosticaConversioni.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticaConversioni.vue?vue&type=style&index=0&id=506caa8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506caa8e",
  null
  
)

export default component.exports